exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cof-field[data-v-010d4db4] {\n  margin-right: 5px;\n}\n.errors[data-v-010d4db4] {\n  color: #ff0000 !important;\n}\n.key-wrap[data-v-010d4db4] {\n  max-width: 100px;\n  word-wrap: break-word;\n}\n.fee-checkbox[data-v-010d4db4] {\n  -webkit-appearance: checkbox;\n}\n.content-table strong.c1[data-v-010d4db4] {\n  color: #13ce67;\n}\n.content-table strong.c2[data-v-010d4db4] {\n  color: #ffa700;\n}\n.content-table strong.c3[data-v-010d4db4] {\n  color: #41566c;\n}\n.content-table strong.c4[data-v-010d4db4] {\n  color: #e23434;\n}\n.content-tlist[data-v-010d4db4] {\n  border: none;\n}", ""]);

// exports
